export enum AccordionItemDataAttributes {
  /**
   * Indicates the index of the accordion item.
   * @type {number}
   */
  index = 'data-index',
  /**
   * Present when the accordion item is disabled.
   */
  disabled = 'data-disabled',
  /**
   * Present when the accordion item is open.
   */
  open = 'data-open',
}
